import { uniq } from 'lodash';
import { useMemo } from 'react';

import { AvatarEvmNft } from '@repo/types-client';

/**
 * Custom hook to get unique wallet addresses from a list of avatar NFTs.
 * @function useAvatarWallets
 * @param {AvatarEvmNft[] | undefined} avatars - The list of avatar NFTs.
 * @returns {string[]} An array of unique wallet addresses.
 */
export const useAvatarWallets = (avatars: AvatarEvmNft[] | undefined) => {
  return useMemo(() => uniq(avatars?.map((avatar) => avatar.owner)), [avatars]);
};
